export const Statuses = [
    { id: 0, name: 'All' },
    { id: 1, name: 'Draft', cssClass: 'draft-status' },
    { id: 2, name: 'In Progress', cssClass: 'in-progress-status' },
    { id: 3, name: 'Needs Approval', cssClass: 'needs-approval-status' },
    // Disabled "Urgent" for now until we decide what to do with this status
    // { id: 4, name: 'Urgent', cssClass: 'urgent-status' },
    { id: 5, name: 'Finished', cssClass: 'done-status' },
    { id: 6, name: 'New', cssClass: 'new-status' },
    { id: 7, name: 'Messaged Lab', cssClass: 'messaged-lab-status' },
    { id: 8, name: 'Cancelled', cssClass: 'closed-status' },
    { id: 10, name: 'Printing', cssClass: 'printing-status' },
];
export const SubStatus = [{ id: 100, name: 'Revision Requested', cssClass: 'revision-requested-status' }];

export const StatusesTranslated = [
    { id: 0, name: 'general.all', order: 0 },
    { id: 1, name: 'general.draft', cssClass: 'draft-status-v2', order: 2 },
    { id: 2, name: 'general.inProgress', cssClass: 'in-progress-status-v2', order: 3 },
    { id: 3, name: 'general.needsApproval', cssClass: 'needs-approval-status-v2', order: 1 },
    // Disabled "Urgent" for now until we decide what to do with this status (for v2 his name is "Needs Attention")
    // { id: 4, name: 'general.needsAttention', cssClass: 'needs-attention-status-v2' , order: 0 },
    { id: 5, name: 'general.finished', cssClass: 'finished-status-v2', order: 6 },
    { id: 6, name: 'general.new', cssClass: 'new-status-v2', order: 5 },
    { id: 7, name: 'general.messagedLab', cssClass: 'messaged-lab-status-v2', order: 4 },
    { id: 8, name: 'general.cancelled', cssClass: 'closed-status-v2', order: 7 },
    { id: 10, name: 'general.printing', cssClass: 'printing-status-v2', order: 9 },
];
export interface StatusesTranslatedItem {
    id: number;
    name: string;
    cssClass?: string;
    order: number;
}
export const StatusIds = {
    all: 0,
    draft: 1,
    inProgress: 2,
    needsApproval: 3,
    urgent: 4,
    done: 5,
    new: 6,
    messagedLab: 7,
    closed: 8,
    printing: 10,
};

export const ActiveStatusIds = [
    2, // inProgress
    3, // needsApproval
    6, // new
    7, // messagedLab
    10,
];
